import { render, staticRenderFns } from "./MentorGoalsSettings.vue?vue&type=template&id=4bb39e26"
import script from "./MentorGoalsSettings.vue?vue&type=script&lang=js"
export * from "./MentorGoalsSettings.vue?vue&type=script&lang=js"
import style0 from "./MentorGoalsSettings.vue?vue&type=style&index=0&id=4bb39e26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports